module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7soDP"))).then(() => module.bundle.root('aVi2q'));